import * as React from "react";
import { Form } from "antd";
import CustomFieldElement from "./CustomFieldElement";
import { IRenderCustomFieldData } from "src/admin/Organization/CustomFields/CustomFieldContainer";

interface IProps {
	style?: {};
	customFieldData: IRenderCustomFieldData;
}

export const RenderedCustomField: React.FC<IProps> = (props) => {
	return (
		<React.Fragment key={props.customFieldData.id!}>
			<div
				className={`${
					props.customFieldData.responsive ? "col-lg-3 col-md-6" : "col-3"
				} form-group`}
			>
				<label htmlFor={`control-${props.customFieldData.name}`}>
					{props.customFieldData.name}
					{props.customFieldData.required ? "*" : ""}
				</label>
				<Form.Item
					hasFeedback={true}
					validateStatus={props.customFieldData!.validation.validationStatus}
					help={props.customFieldData!.validation.message}
				>
					<CustomFieldElement
						style={props.style}
						key={props.customFieldData.id!}
						name={props.customFieldData.name!}
						placeholder={props.customFieldData.placeholderText}
						fieldId={props.customFieldData.id!}
						type={props.customFieldData.type}
						options={props.customFieldData.options}
						value={props.customFieldData.value}
						onChange={(e: any) =>
							props.customFieldData.onChangeCustomFieldValue(
								props.customFieldData.id,
								e
							)
						}
					/>
				</Form.Item>
			</div>
		</React.Fragment>
	);
};
